module.exports = __webpack_public_path__ + "static/media/27OCHA8.bfe97886.jpg";